<script>
export default {
  name: 'CheckPayment',
  data () {
    return {
      id: null,
      done: null,
      time: 0,
      interval: null,
      tries: 0,
      maxTries: 10
    }
  },
  methods: {
    checkPayment () {
      this.tries++
      if (!this.done) {
        this.$http.get(`/gopay/check/${this.id}/${this.tries}`)
          .then((response) => {
            if (response.data) {
              this.done = response.data.paid
            }
          })
      }
      if (
        this.tries >= this.maxTries ||
        this.done !== null
      ) this.donePayment()
    },
    donePayment () {
      setTimeout(() => this.$router.push({ name: 'user.orderHistory' }), 2000)
    }
  },
  mounted () {
    this.id = this.$route.params.id
    this.checkPayment()
    this.interval = setInterval(() => {
      if (this.tries >= this.maxTries || this.done != null) {
        this.donePayment()
        clearInterval(this.interval)
      }
      this.checkPayment()
    }, 1500)
  }
}
</script>

<template>
  <v-container>
    <div class="d-flex text-center mt-10 justify-center" style="width: 100%">
      <div v-if="this.done === null" class="d-flex">
        <v-progress-circular
          indeterminate
          color="green"
          class="mr-10"
          size="50"
          width="5"
        ></v-progress-circular>
        <h1>Platba se zpracovává</h1>
      </div>
      <div v-else-if="this.done === false" class="d-flex">
        <v-icon
          color="red"
          class="mr-10"
          size="50"
        >mdi-close-circle-outline</v-icon>
        <h1>Platba se nezdařila</h1>
      </div>
      <div v-else-if="this.done === true" class="d-flex">
        <v-icon
          color="green"
          class="mr-10"
          size="50"
        >mdi-check-circle</v-icon>
        <h1>Platba proběhla v pořádku</h1>
      </div>
    </div>
  </v-container>
</template>

<style scoped>

</style>
